var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelatorio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.9,
    height: 11.375,
    viewBox: "0 0 9.9 11.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "relatorio",
    transform: "translate(-0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1621",
    "data-name": "Caminho 1621",
    d: "M0,5.684q0-2,0-3.993A1.638,1.638,0,0,1,1.114.1,1.861,1.861,0,0,1,1.69.006Q4.949,0,8.208,0A1.646,1.646,0,0,1,9.9,1.7q0,3.987,0,7.975a1.651,1.651,0,0,1-1.408,1.676,1.853,1.853,0,0,1-.311.018c-2.153,0-4.305-.008-6.458,0A1.68,1.68,0,0,1,.03,10.012,2.169,2.169,0,0,1,0,9.641Q0,7.663,0,5.684m.951-.007q0,1.991,0,3.982a.708.708,0,0,0,.762.767H8.185a.707.707,0,0,0,.763-.766q0-3.976,0-7.952a.936.936,0,0,0-.019-.215A.706.706,0,0,0,8.192.948c-2.149,0-4.3.006-6.447,0a.76.76,0,0,0-.8.8C.962,3.055.952,4.366.952,5.677",
    transform: "translate(0.002)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1622",
    "data-name": "Caminho 1622",
    d: "M67.034,64.788c-.391.408-.775.806-1.155,1.206a.482.482,0,0,1-.509.161.47.47,0,0,1-.2-.789c.388-.411.781-.817,1.172-1.225.086-.09.17-.181.257-.27a.479.479,0,0,1,.643-.078c.477.3.952.606,1.439.916l.634-.705c.193-.215.385-.43.578-.644a.476.476,0,1,1,.709.626q-.729.816-1.461,1.629a.474.474,0,0,1-.668.087q-.659-.418-1.317-.84l-.122-.076",
    transform: "translate(-62.941 -61.133)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1623",
    "data-name": "Caminho 1623",
    d: "M76.274,191.352q1.052,0,2.1,0a.443.443,0,0,1,.439.295.449.449,0,0,1-.1.5.5.5,0,0,1-.391.149q-1.431,0-2.862,0c-.441,0-.882,0-1.323,0a.472.472,0,0,1-.187-.9.684.684,0,0,1,.246-.039c.689,0,1.379,0,2.068,0",
    transform: "translate(-71.314 -185.214)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1624",
    "data-name": "Caminho 1624",
    d: "M75.112,261.923c.34,0,.681,0,1.021,0a.473.473,0,1,1,0,.944q-1.015,0-2.03,0a.473.473,0,1,1,0-.944c.336,0,.673,0,1.009,0",
    transform: "translate(-71.234 -253.521)",
    fill: "#ffbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatorio);
export default __webpack_public_path__ + "static/media/relatorio.267e8ce11199027dc189eaadd0d109c5.svg";
export { ForwardRef as ReactComponent };